/* tslint:disable */
/* eslint-disable */
// <auto-generated>
//   Generated using custom tool!
// </auto-generated>

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { DefaultAxiosInstance } from './DefaultAxiosInstance';
import { Try } from 'framework/Try';

export async function imageScanner_devices(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IScannerDevice[]>> {
	try {
		let url_ = '/api/scanner/devices';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'text/plain',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function imageScanner_scan(body: IScanModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IScanToPdfResult>> {
	try {
		let url_ = '/api/scanner/scan';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = JSON.stringify(body);

		let options_ = <AxiosRequestConfig>{
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'text/plain',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function meta_build(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
	try {
		let url_ = '/api/meta/build';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'text/plain',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function meta_ping(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<void>> {
	try {
		let url_ = '/api/meta/ping';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function meta_url(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
	try {
		let url_ = '/api/meta/url';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'text/plain',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export interface IScannerDevice {
	deviceId: string | undefined;
	name: string | undefined;
	supportedSources: string[];
}

export interface IScanModel {
	deviceId: string | undefined;
	source: string | undefined;
}

export interface IScanToPdfResult {
	contentAsBase64: string | undefined;
	error: string | undefined;
	hasError: boolean;
}

export type ScanSource = 'Flatbed' | 'Feeder' | 'DuplexFromFeeder' | 'Auto' | 'Default';
export const ScanSources: ScanSource[] = ['Flatbed', 'Feeder', 'DuplexFromFeeder', 'Auto', 'Default'];

export type ScanError = 'DeviceNotFound' | 'SourceNotSupported' | 'NoFiles';
export const ScanErrors: ScanError[] = ['DeviceNotFound', 'SourceNotSupported', 'NoFiles'];
